export default {
  add(cont, item) {
    var delay = 0;
    $(cont).find(item).each(function(i, prod){
      setTimeout(function(){ 
        $(prod).delay(delay).addClass('in'); 
      }, delay);
      delay += 150;
    });
  },
  remove(cont, item) {
    $(cont).find(item).each(function(i, prod){
      $(prod).removeClass('in'); 
    });
  }
}
